// extracted by css-extract-rspack-plugin
export default {"Label":"default-group-header-label-module__Label__NIQ6WV4","AggregateLabels":"default-group-header-label-module__AggregateLabels__WnX35nT"};